<app-side-menu>
  <div class="driver-assignment-container">
    <app-loading [show]="isLoading" message="Carregando informações..."></app-loading>

    <div *ngIf="!isLoading && contract" class="assignment-content">
      <header class="assignment-header">
        <div class="assignment-header-content">
          <div class="assignment-header-left">
            <button class="btn-header-back" (click)="navigateBack()">
              <i class="fas fa-arrow-left"></i>
            </button>
            <div>
              <h1 class="assignment-title">
                <i class="fas fa-users-cog me-2"></i>
                Central de Atribuicao de Condutores
              </h1>
              <p class="assignment-subtitle">
                Contrato: {{ contract.contractNumber }} - {{ contract.contractName }}
              </p>
            </div>
          </div>
          <button class="btn btn-header-voltar" (click)="navigateBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>
      </header>

      <div class="row g-3 mb-4">
        <div class="col-12 col-sm-6 col-lg-3">
          <div class="stat-card">
            <div class="stat-icon icon-indigo">
              <i class="fas fa-users"></i>
            </div>
            <div>
              <h3>{{ driverTotalItems }}</h3>
              <p>Condutores Cadastrados</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <div class="stat-card">
            <div class="stat-icon icon-sky">
              <i class="fas fa-list"></i>
            </div>
            <div>
              <h3>{{ itemsTotal }}</h3>
              <p>Itens do Contrato</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <div class="stat-card">
            <div class="stat-icon icon-emerald">
              <i class="fas fa-motorcycle"></i>
            </div>
            <div>
              <h3>{{ getAvailableVehiclesCount() }}</h3>
              <p>Veiculos Disponiveis</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <div class="stat-card">
            <div class="stat-icon icon-amber">
              <i class="fas fa-link"></i>
            </div>
            <div>
              <h3>{{ getAssignedVehiclesCount() }}</h3>
              <p>Veiculos Atribuidos</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-4 align-items-start">
        <div class="col-12 col-lg-4">
          <div class="panel-card panel-card-left">
            <div class="panel-header">
              <h2>
                <i class="fas fa-users me-2"></i>
                Condutores ({{ drivers.length }}/{{ driverTotalItems }})
              </h2>
            </div>

            <div class="panel-filter">
              <div class="input-wrap">
                <i class="fas fa-search input-icon"></i>
                <input
                  type="text"
                  class="form-control input-modern"
                  placeholder="Buscar condutor..."
                  [(ngModel)]="driverSearchTerm"
                  (ngModelChange)="onDriverSearchChange()"
                  [ngModelOptions]="{standalone: true}">
              </div>
            </div>

            <div class="panel-scroll">
              <app-loading [show]="isLoadingDrivers" message="Carregando condutores..."></app-loading>

              <div *ngIf="!isLoadingDrivers && filteredDrivers.length > 0" class="driver-list">
                <div *ngFor="let driver of filteredDrivers" class="driver-item">
                  <div class="driver-avatar">
                    <i class="fas fa-user"></i>
                  </div>
                  <div class="driver-text">
                    <h4>{{ driver.name || 'N/A' }}</h4>
                    <p><i class="fas fa-id-card me-1"></i>{{ formatCpf(driver.driverCpf) }}</p>
                    <small><i class="fas fa-phone me-1"></i>{{ formatPhone(driver.phone) }}</small>
                    <small><i class="fas fa-envelope me-1"></i>{{ driver.email || 'N/A' }}</small>
                  </div>
                </div>
              </div>

              <div *ngIf="!isLoadingDrivers && drivers.length > 0 && filteredDrivers.length === 0" class="empty-state">
                <i class="fas fa-search"></i>
                <p>Nenhum condutor encontrado com o termo de busca.</p>
              </div>

              <div *ngIf="!isLoadingDrivers && drivers.length === 0" class="empty-state">
                <i class="fas fa-users"></i>
                <h4>Nenhum condutor encontrado</h4>
                <p>{{ driverSearchTerm ? 'Nenhum condutor corresponde à busca.' : 'Cadastre condutores para este contrato primeiro.' }}</p>
              </div>
            </div>
            <div class="panel-pager" *ngIf="!isLoadingDrivers && driverTotalItems > 0">
              <small>Pagina {{ driverPageNumber }} de {{ driverTotalPages }}</small>
              <div class="d-flex align-items-center gap-2">
                <div class="btn-group btn-group-sm">
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                    [disabled]="!driverHasPreviousPage || isLoadingDrivers"
                    (click)="onDriverPageChange(driverPageNumber - 1)">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                    [disabled]="!driverHasNextPage || isLoadingDrivers"
                    (click)="onDriverPageChange(driverPageNumber + 1)">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
                <select class="form-select form-select-sm pager-size" [value]="driverPageSize"
                  (change)="onDriverPageSizeChange(+$any($event.target).value)">
                  <option [value]="10">10</option>
                  <option [value]="20">20</option>
                  <option [value]="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-8">
          <div class="panel-card panel-card-right">
            <div class="panel-header d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h2>
                <i class="fas fa-users me-2"></i>
                Veiculos dos Itens ({{ vehicles.length }}/{{ vehicleTotalItems }})
              </h2>
            </div>

            <div class="panel-filter panel-filter-row">
              <div class="input-wrap flex-grow-1">
                <i class="fas fa-search input-icon"></i>
                <input
                  type="text"
                  class="form-control input-modern"
                  placeholder="Buscar veiculo por placa, modelo..."
                  [(ngModel)]="vehicleSearchTerm"
                  (ngModelChange)="onVehicleSearchChange()"
                  [ngModelOptions]="{standalone: true}">
              </div>
              <div class="select-wrap">
                <select
                  class="form-select input-modern"
                  [ngModel]="vehicleFilter"
                  (ngModelChange)="onVehicleFilterChange($event)"
                  [ngModelOptions]="{standalone: true}">
                  <option value="all">Todos os Veiculos</option>
                  <option value="available">Disponiveis</option>
                  <option value="assigned">Atribuidos</option>
                </select>
              </div>
            </div>

            <div class="panel-scroll">
              <app-loading [show]="isLoadingItems" message="Carregando veículos..."></app-loading>

              <div *ngIf="!isLoadingItems && filteredVehicles.length > 0" class="vehicles-grid">
                <div *ngFor="let vehicle of filteredVehicles" class="vehicle-card" [class.vehicle-card-assigned]="vehicle.hasDriver">
                  <div class="vehicle-card-top">
                    <div class="vehicle-id-wrap">
                      <div class="vehicle-icon" [class.vehicle-icon-assigned]="vehicle.hasDriver">
                        <i class="fas fa-motorcycle"></i>
                      </div>
                      <div>
                        <h3 class="vehicle-plate">{{ vehicle.plate }}</h3>
                        <p class="vehicle-label">Placa</p>
                      </div>
                    </div>
                    <span *ngIf="vehicle.hasDriver" class="vehicle-badge badge-assigned">Atribuido</span>
                    <span *ngIf="!vehicle.hasDriver" class="vehicle-badge badge-available">Disponivel</span>
                  </div>

                  <div class="vehicle-meta">
                    <p>{{ vehicle.brand }} {{ vehicle.model }} - {{ vehicle.year }}</p>
                    <small>Cor: {{ getVehicleColorLabel(vehicle.color) }}</small>
                    <small *ngIf="vehicle.itemNumber && vehicle.itemNumber !== '—'" class="d-block">Pedido: {{ vehicle.itemNumber }}</small>
                  </div>

                  <div class="vehicle-footer">
                    <div *ngIf="vehicle.hasDriver" class="vehicle-driver-chip">
                      <div class="driver-chip-text">
                        <span>Condutor</span>
                        <strong>
                          {{ displayDriverName(vehicle) }}
                        </strong>
                      </div>
                      <div class="driver-chip-actions">
                        <button class="btn-chip-icon" (click)="viewAssignment(vehicle)" title="Visualizar Detalhes">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button class="btn-chip-icon btn-chip-danger" (click)="removeAssignment(vehicle)" title="Remover Condutor">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <button
                      *ngIf="!vehicle.hasDriver"
                      class="btn btn-link-driver"
                      (click)="openAssignmentModal(vehicle)">
                      <i class="fas fa-link me-2"></i>
                      Vincular Condutor
                    </button>
                  </div>
                </div>
              </div>

              <div *ngIf="!isLoadingItems && vehicles.length === 0" class="empty-state">
                <i class="fas fa-motorcycle"></i>
                <h4>Nenhum veiculo encontrado</h4>
                <p>Este contrato nao possui veiculos cadastrados nos itens.</p>
              </div>
            </div>
            <div class="panel-pager" *ngIf="!isLoadingItems && vehicleTotalItems > 0">
              <small>Pagina {{ vehiclePageNumber }} de {{ vehicleTotalPages }}</small>
              <div class="d-flex align-items-center gap-2">
                <div class="btn-group btn-group-sm">
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                    [disabled]="!vehicleHasPreviousPage || isLoadingItems"
                    (click)="onVehiclePageChange(vehiclePageNumber - 1)">
                    <i class="fas fa-chevron-left"></i> Anterior
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                    [disabled]="!vehicleHasNextPage || isLoadingItems"
                    (click)="onVehiclePageChange(vehiclePageNumber + 1)">
                    Proxima <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
                <select class="form-select form-select-sm pager-size" [value]="vehiclePageSize"
                  (change)="onVehiclePageSizeChange(+$any($event.target).value)">
                  <option [value]="10">10</option>
                  <option [value]="20">20</option>
                  <option [value]="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Vinculação -->
  <app-modal
    [isOpen]="showAssignmentModal"
    [title]="'Vincular Condutor ao Veículo'"
    [size]="'lg'"
    (close)="closeAssignmentModal()">
    
    <div *ngIf="selectedVehicle" class="vehicle-preview mb-4">
      <div class="alert alert-info">
        <h6 class="mb-2">
          <i class="fas fa-motorcycle me-2"></i>
          Veículo Selecionado
        </h6>
        <p class="mb-1"><strong>Placa:</strong> {{ selectedVehicle.plate }}</p>
        <p class="mb-1"><strong>Modelo:</strong> {{ selectedVehicle.brand }} {{ selectedVehicle.model }} - {{ selectedVehicle.year }}</p>
        <p class="mb-0"><strong>Item:</strong> {{ selectedVehicle.itemNumber }}</p>
      </div>
    </div>

    <form [formGroup]="assignmentForm" (ngSubmit)="onSubmitAssignment()">
      <div class="row g-3">
        <div class="col-12">
          <label class="form-label">Condutor <span class="text-danger">*</span></label>
          <div class="modal-driver-search mb-2">
            <i class="fas fa-search"></i>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="modalDriverSearchTerm"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onModalDriverSearchChange()"
              placeholder="Buscar por nome, CPF ou CNH..."
              autocomplete="off" />
          </div>
          <select
            class="form-control"
            formControlName="driverId"
            [class.is-invalid]="assignmentForm.get('driverId')?.invalid && assignmentForm.get('driverId')?.touched"
            [disabled]="isLoadingModalDrivers">
            <option value="">
              {{ isLoadingModalDrivers ? 'Carregando condutores...' : (filteredModalDrivers.length ? 'Selecione um condutor' : 'Nenhum condutor encontrado') }}
            </option>
            <option *ngFor="let driver of filteredModalDrivers" [value]="driver.id" [disabled]="isDriverAlreadyAssigned(driver.id).assigned && (!selectedVehicle?.driverAssociation || (selectedVehicle?.driverAssociation?.b2BContractDriverId !== driver.id && selectedVehicle?.driverAssociation?.B2BContractDriverId !== driver.id))">
              {{ driver.name }} - {{ formatCpf(driver.driverCpf) }}
              <ng-container *ngIf="isDriverAlreadyAssigned(driver.id).assigned && (!selectedVehicle?.driverAssociation || (selectedVehicle?.driverAssociation?.b2BContractDriverId !== driver.id && selectedVehicle?.driverAssociation?.B2BContractDriverId !== driver.id))">
                (Já vinculado ao veículo {{ isDriverAlreadyAssigned(driver.id).vehiclePlate }})
              </ng-container>
            </option>
          </select>
          <small class="form-text text-muted" *ngIf="!isLoadingModalDrivers">
            {{ filteredModalDrivers.length }} condutor(es) encontrado(s)
          </small>
          <div class="invalid-feedback" *ngIf="assignmentForm.get('driverId')?.invalid && assignmentForm.get('driverId')?.touched">
            Campo obrigatório
          </div>
          <small class="form-text text-muted" *ngIf="assignmentForm.get('driverId')?.value">
            <span *ngIf="isDriverAlreadyAssigned(+assignmentForm.get('driverId')?.value).assigned && (!selectedVehicle?.driverAssociation || selectedVehicle?.driverAssociation?.b2BContractDriverId !== +assignmentForm.get('driverId')?.value && selectedVehicle?.driverAssociation?.B2BContractDriverId !== +assignmentForm.get('driverId')?.value)" class="text-danger">
              <i class="fas fa-exclamation-triangle me-1"></i>
              Este condutor já está vinculado ao veículo {{ isDriverAlreadyAssigned(+assignmentForm.get('driverId')?.value).vehiclePlate }}. 
              Um condutor não pode ser atribuído a mais de um veículo simultaneamente.
            </span>
          </small>
        </div>

        <div class="col-md-6">
          <label class="form-label">Data de Início <span class="text-danger">*</span></label>
          <input
            type="date"
            class="form-control"
            formControlName="startDate"
            [class.is-invalid]="assignmentForm.get('startDate')?.invalid && assignmentForm.get('startDate')?.touched">
          <div class="invalid-feedback" *ngIf="assignmentForm.get('startDate')?.invalid && assignmentForm.get('startDate')?.touched">
            Campo obrigatório
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Data de Término</label>
          <input
            type="date"
            class="form-control"
            formControlName="endDate">
        </div>

        <div class="col-md-6">
          <label class="form-label">Status <span class="text-danger">*</span></label>
          <select
            class="form-control"
            formControlName="status"
            [class.is-invalid]="assignmentForm.get('status')?.invalid && assignmentForm.get('status')?.touched">
            <option value="Active">Ativo</option>
            <option value="Inactive">Inativo</option>
            <option value="Pending">Pendente</option>
          </select>
          <div class="invalid-feedback" *ngIf="assignmentForm.get('status')?.invalid && assignmentForm.get('status')?.touched">
            Campo obrigatório
          </div>
        </div>

        <div class="col-12">
          <label class="form-label">Observações</label>
          <textarea
            class="form-control"
            formControlName="notes"
            rows="3"
            placeholder="Ex: Condutor responsável pela moto. Rastreador instalado e funcionando."></textarea>
        </div>
      </div>

      <div slot="footer" class="modal-footer-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeAssignmentModal()" [disabled]="isSubmitting">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="assignmentForm.invalid || isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSubmitting" class="fas fa-link me-2"></i>
          {{ isSubmitting ? 'Vinculando...' : 'Vincular Condutor' }}
        </button>
      </div>
    </form>
  </app-modal>

  <!-- Modal desvincular condutor -->
  <app-modal
    [isOpen]="showUnassignModal"
    [title]="'Desvincular condutor'"
    [size]="'md'"
    (close)="closeUnassignModal()">
    <div *ngIf="vehicleToUnassign" class="mb-3">
      <div class="alert alert-warning py-2 small mb-3">
        <strong>Placa:</strong> {{ vehicleToUnassign.plate }}
      </div>
      <form [formGroup]="unassignForm" (ngSubmit)="submitUnassign()">
        <div class="mb-3">
          <label class="form-label">Motivo <span class="text-danger">*</span></label>
          <select
            class="form-control"
            formControlName="motivo"
            [class.is-invalid]="unassignForm.get('motivo')?.invalid && unassignForm.get('motivo')?.touched">
            <option value="">Selecione o motivo</option>
            <option *ngFor="let opt of desvincularMotivoOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <div class="invalid-feedback" *ngIf="unassignForm.get('motivo')?.invalid && unassignForm.get('motivo')?.touched">
            Selecione o motivo
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Data/hora (opcional)</label>
          <input type="datetime-local" class="form-control" formControlName="returnDate" />
        </div>
        <div slot="footer" class="modal-footer-buttons">
          <button type="button" class="btn btn-secondary" (click)="closeUnassignModal()" [disabled]="isSubmitting">
            Cancelar
          </button>
          <button type="submit" class="btn btn-danger" [disabled]="isSubmitting">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
            {{ isSubmitting ? 'Desvinculando...' : 'Desvincular' }}
          </button>
        </div>
      </form>
    </div>
  </app-modal>

  <!-- Modal 2: descrever motivo quando selecionar Outro -->
  <app-modal
    [isOpen]="showUnassignOutroModal"
    [title]="'Descreva o motivo'"
    [size]="'md'"
    (close)="closeUnassignOutroModal()">
    <div *ngIf="vehicleToUnassign" class="mb-3">
      <div class="alert alert-warning py-2 small mb-3">
        <strong>Placa:</strong> {{ vehicleToUnassign.plate }}
      </div>
      <form [formGroup]="unassignOutroForm" (ngSubmit)="submitUnassignOutro()">
        <div class="mb-3">
          <label class="form-label">Motivo <span class="text-danger">*</span></label>
          <textarea
            class="form-control"
            formControlName="detalhe"
            rows="4"
            [attr.maxlength]="500"
            [placeholder]="'Descreva o motivo (mínimo ' + desvincularOutroMinLength + ' caracteres)'"
            [class.is-invalid]="unassignOutroForm.get('detalhe')?.invalid && unassignOutroForm.get('detalhe')?.touched">
          </textarea>
          <div class="invalid-feedback" *ngIf="unassignOutroForm.get('detalhe')?.invalid && unassignOutroForm.get('detalhe')?.touched">
            Informe o motivo com pelo menos {{ desvincularOutroMinLength }} caracteres.
          </div>
        </div>
        <div slot="footer" class="modal-footer-buttons">
          <button type="button" class="btn btn-secondary" (click)="closeUnassignOutroModal()" [disabled]="isSubmitting">
            Voltar
          </button>
          <button type="submit" class="btn btn-danger" [disabled]="isSubmitting">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
            {{ isSubmitting ? 'Desvinculando...' : 'Confirmar desvínculo' }}
          </button>
        </div>
      </form>
    </div>
  </app-modal>

  <!-- Modal de Visualização de Vinculação -->
  <app-modal
    [isOpen]="showViewModal"
    [title]="'Detalhes da Vinculação'"
    [size]="'lg'"
    (close)="closeViewModal()">
    
    <app-loading [show]="isLoadingAssignmentDetails" message="Carregando detalhes..."></app-loading>
    
    <div *ngIf="!isLoadingAssignmentDetails && assignmentDetails">
      <!-- Informações do Veículo -->
      <div class="card mb-3 border-primary">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0">
            <i class="fas fa-motorcycle me-2"></i>
            Informações do Veículo
          </h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <strong>Placa:</strong>
              <p class="mb-0">{{ assignmentDetails?.VehiclePlate || assignmentDetails?.vehiclePlate || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <strong>Modelo:</strong>
              <p class="mb-0">{{ assignmentDetails?.VehicleModel || assignmentDetails?.vehicleModel || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <strong>Marca:</strong>
              <p class="mb-0">{{ assignmentDetails?.VehicleBrand || assignmentDetails?.vehicleBrand || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <strong>Item do Contrato:</strong>
              <p class="mb-0">{{ assignmentDetails?.ItemNumber || assignmentDetails?.itemNumber || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações do Condutor -->
      <div class="card mb-3 border-success">
        <div class="card-header bg-success text-white">
          <h5 class="mb-0">
            <i class="fas fa-user me-2"></i>
            Informações do Condutor
          </h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <strong>Nome:</strong>
              <p class="mb-0">{{ assignmentDetails?.DriverName || assignmentDetails?.driverName || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <strong>CPF:</strong>
              <p class="mb-0">{{ formatCpf(assignmentDetails?.DriverCpf || assignmentDetails?.driverCpf || '') }}</p>
            </div>
            <div class="col-md-6">
              <strong>CNH:</strong>
              <p class="mb-0">{{ assignmentDetails?.DriverCnh || assignmentDetails?.driverCnh || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <strong>Telefone:</strong>
              <p class="mb-0">{{ formatPhone(assignmentDetails?.DriverPhone || assignmentDetails?.driverPhone || '') }}</p>
            </div>
            <div class="col-md-6">
              <strong>Email:</strong>
              <p class="mb-0">{{ assignmentDetails?.DriverEmail || assignmentDetails?.driverEmail || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <strong>Endereço:</strong>
              <p class="mb-0">{{ assignmentDetails?.DriverAddress || assignmentDetails?.driverAddress || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações da Vinculação -->
      <div class="card mb-3 border-info">
        <div class="card-header bg-info text-white">
          <h5 class="mb-0">
            <i class="fas fa-link me-2"></i>
            Informações da Vinculação
          </h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <strong>Data de Início:</strong>
              <p class="mb-0">{{ formatDate(assignmentDetails?.StartDate || assignmentDetails?.startDate) }}</p>
            </div>
            <div class="col-md-6">
              <strong>Data de Término:</strong>
              <p class="mb-0">{{ formatDate(assignmentDetails?.EndDate || assignmentDetails?.endDate) }}</p>
            </div>
            <div class="col-md-6">
              <strong>Status:</strong>
              <p class="mb-0">
                <span *ngIf="(assignmentDetails?.Status || assignmentDetails?.status) === 'Active'" class="badge badge-success">Ativo</span>
                <span *ngIf="(assignmentDetails?.Status || assignmentDetails?.status) === 'Inactive'" class="badge badge-danger">Inativo</span>
                <span *ngIf="(assignmentDetails?.Status || assignmentDetails?.status) === 'Pending'" class="badge badge-warning">Pendente</span>
                <span *ngIf="!(assignmentDetails?.Status || assignmentDetails?.status)" class="badge badge-secondary">N/A</span>
              </p>
            </div>
            <div class="col-md-6">
              <strong>ID da Vinculação:</strong>
              <p class="mb-0">{{ assignmentDetails?.Id || assignmentDetails?.id || 'N/A' }}</p>
            </div>
            <div class="col-12" *ngIf="assignmentDetails?.Notes || assignmentDetails?.notes">
              <strong>Observações:</strong>
              <p class="mb-0">{{ assignmentDetails?.Notes || assignmentDetails?.notes }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="modal-footer-buttons">
      <button type="button" class="btn btn-secondary" (click)="closeViewModal()">
        Fechar
      </button>
    </div>
  </app-modal>
</app-side-menu>
